import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LoadingSpinnerBorderComponent } from "../../shared/components/loading/loading-spinner-border/loading-spinner-border.component";
import { ConsentService } from '../../shared/services/consent.service';
import { CmsProjectGroupByTag, CmsEntry } from '../../shared/models/cms-data.model';

@Component({
    selector: 'delete-data-dialog',
    imports: [CommonModule, TranslocoDirective, ReactiveFormsModule, LoadingSpinnerBorderComponent],
    templateUrl: './delete-data-dialog.component.html'
})
export class DeleteDataDialogComponent implements OnInit {
    private consentService = inject(ConsentService);
    private router = inject(Router)
    private fb = inject(FormBuilder);
    private route = inject(ActivatedRoute);

    @Input() userHasConsent: boolean | undefined;

    withdrawConsentForm!: FormGroup;
    onConfirming: boolean = false;
    isLoading: boolean = false;
    hasError: boolean = false;
    errorText: string = "";


    groupData: CmsProjectGroupByTag[] = [];
    cmsEntries: { [key: string]: CmsEntry | undefined } = {};

    ngOnInit(): void {
        this.withdrawConsentForm = this.fb.group({
            cprNumber: new FormControl(''),
        });

        this.route.data.subscribe({
            next: (data: Data) => {
                this.groupData = data['patientProfileContent'];
                const entries = this.groupData[0].entries;
                this.cmsEntries = {
                    entry1: entries[0],
                };
            },
            error: () => {
                this.isLoading = false;
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    }

    onConfirm(): void {
        this.isLoading = true;
        this.consentService.postWithdrawPatientConsent$(this.withdrawConsentForm.get("cprNumber")?.value).subscribe({
            next: result => {
                this.isLoading = false
                this.router.navigate(["/auth/logout"])
            },
            error: err => {
                if (err.error === "Cpr did not match") {
                    this.errorText = "patientprofile.personaldata.errormessage.invalidcpr";
                } else {
                    this.errorText = "patientprofile.personaldata.errormessage.unknownerror";
                }
                this.hasError = true;
                this.isLoading = false;
            }
        });
    }

    resetInputs(): void {
        this.withdrawConsentForm.reset();
        this.hasError = false;
        this.errorText = "";
    }

}
